export enum WizardTranslationKey {
    BACK = "tools.importExportWizard.configuration.back",
    NEXT = "tools.importExportWizard.configuration.next",
    EXIT = "tools.importExportWizard.configuration.exit",
}